<template>
    <div class="page-languages">
        <div class="cadre">
            <page-corners/>
        </div>

        <div>
            <h2>Les royaumes de</h2>
            <h1>Madagascar</h1>
            <Languages/>
        </div>
    </div>
</template>

<script>
    import Languages from "shared-src/langues/languages";
    import PageCorners from "shared-src/decoration/PageCorners";
    export default {
        name: "PageLanguages",
        components: {PageCorners, Languages},
        methods:{
        }
    }
</script>

<style lang="less">
    .page-languages{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        .cadre{
            position: absolute;
            width: calc(100% - 6vw );
            height: calc(100% - 6vw );
          animation-name: grossit;
          animation-duration: 5s;
          animation-iteration-count: infinite;
          animation-direction: alternate;
          animation-timing-function: ease-in-out;
        }
        h1,h2{
            line-height: 1.3;
            margin: 0;
            font-weight: normal;
          animation-name: flotte;
          animation-duration: 10s;
          animation-iteration-count: infinite;
          animation-direction: alternate-reverse;
          animation-timing-function: ease-in-out;
        }
        h1{
            font-size: 4.8vw;
            animation-delay: -5s;
          animation-direction: alternate;
        }
        h2{
          font-size: 3.2vw;
          animation-delay: -5s;
        }
        .languages{
            margin-top: 3vw;
        }

        @keyframes flotte{
          0% {
            transform: translateX(-2vw);
          }

          100% {
            transform: translateX(2vw);
          }
        }
      @keyframes grossit{
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(0.98);
        }
      }




    }
</style>